import axios from "@/api/axiosInstance";
import {
  FetchEmployeesRequest,
  FetchEmployeesResponse,
} from "@/modules/administration/features/EmployeeDirectoryManagement/api/Employee/fetchEmployees/types";

export const fetchEmployees = async (
  params: FetchEmployeesRequest = {},
): Promise<FetchEmployeesResponse> => {
  const response = await axios.get<FetchEmployeesResponse>(
    "/api/private/employee-directory/employees",
    { params },
  );
  return response.data;
};
